<template>
  <el-row>
    <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4' v-loading="loadingAssignedApplications">
      <!-- Not needed any more, prints will have one queue-->
      <!-- if needed to load applications from a queue -->
      <el-card class="newApplicationsMenu">
        <div class="text item">
          <li class="list-group-item" :key="0" @click="toggleNewApplications">
            <el-card>
              <div @click="loadAppsOpenDialog">
                <span>Ανάληψη-Αποδέσμευση</span>
              </div>
            </el-card>
          </li>
        </div>
      </el-card>
      <applications-lane :assignedApplications="assignedApplications" :assignedApps="assignedApps">
      </applications-lane>
    </el-col>
    <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-dialog title="Ανάληψη-Αποδέσμευση" :visible.sync="dialogView" width="90%"
          :close-on-click-modal='false' :close-on-press-escape='false' :show-close='true' :center='true'>
            <div style="text-align: center; margin-top: 5px">
              <el-transfer v-loading="loadingAllApplications"
                style="margin-top: 5px; text-align: left; display: inline-block"
                v-model="myApplications"
                filterable
                :titles="['Νέες Αιτήσεις', 'Οι Αιτήσεις μου']"
                :button-texts="['Αποδέσμευση', 'Ανάληψη']"
                :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
                :data="allApplications"
                @change="newAssignedApplications"
                @left-check-change="appsToAssignChanged"
                @right-check-change="appsToReleaseChanged">
              </el-transfer>
            </div>
            <div style="text-align: center">
              <el-button type="primary"
                icon="el-icon-error" @click="dialogView = false, toggleNewApplications" plain round>Κλείσιμο
              </el-button>
              <el-button type="success" icon="el-icon-refresh" plain round
                @click="loadPrintDecisionsApplications">Ανανέωση
              </el-button>
            </div>
          </el-dialog>
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
             <UserAppInfo></UserAppInfo>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true :tab-position="tabPosition">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane v-if="!isReappraisal && !isPostExam" label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                  v-if='workingApplication.degreeType === "bachelor" && workingApplication.consideration === true'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
                <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :userComment="workingApplication.userComment"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :appId="workingApplication.id"
                    :role="role"
                    :generalCommentProp="generalCommentInDocs"
                    :generalCommentWorking="generalCommentWorking"
                    :neededDocuments="workingApplication.neededDocuments"
                    @changedAttachedDocs='changedAttachedDocsEvent'
                    @changedGeneralComment="changedGeneralCommentEvent">
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="sixth">
                  <print-decision-judgment
                    :application='workingApplication'
                    :judgmentDocs="judgmentDocs"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :generalComment="generalComment"
                    :isReappraisal="isReappraisal"
                    :isPostExam="isPostExam"
                    :isSecondReappraisal="isSecondReappraisal">
                  </print-decision-judgment>
                </el-tab-pane>
                <el-tab-pane label="Σχετική αίτηση" name="seventh" v-if="isReappraisal || isPostExam">
                  <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
              </el-tab-pane>
              <el-tab-pane label="Αρχική επανεξέταση" name="eighth" v-if="isSecondReappraisal">
                <first-reappraisal :relevantReappraisalApplication="workingApplication.relevantReappraisalApplication"
                 :relevantReappraisalAppl="workingApplication.relevantReappraisalAppl"></first-reappraisal>
              </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
      </el-col>
    </transition>
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import PrintDecisionJudgment from './roleSpecific/PrintDecisionJudgment'
import ApplicationsLane from './common/ApplicationsLane'
import axios from 'axios'
import UserAppInfo from './common/UserAppInfo'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import sharedMethods from './common/sharedMethods.js'
import SearchUni from '@/components/common/SearchUni'
import RelevantApp from './common/RelevantApp'
import FirstReappraisal from './common/FirstReappraisal'

export default {
  name: 'PrintDecision',
  components: {
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    PrintDecisionJudgment,
    ApplicationsLane,
    UserAppInfo,
    ApplicationSearch,
    SearchUni,
    RelevantApp,
    FirstReappraisal
  },
  mixins: [sharedMethods],
  mounted: function () {
    // todo: called twice?
    this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', 'printdecisionw_')
    this.loadAssignedApplications()
  },
  data () {
    return {
      appsToRelease: [],
      appsToAssign: [],
      dialogView: false,
      assignedApps: {printdecisionw_: [{ id: '1', surname: '', submittedAt: '', degreeType: '' }]},
      role: 'printdecision',
      tabPosition: 'top',
      activeName: 'sixth',
      notificationsDialogVisible: false,
      openNewApplications: false,
      listAssignedApplications: [],
      listPrintDecisionApplications: [],
      viewApplication: {},
      applicationView: false,
      myApplications: [],
      allApplications: [],
      loadingAllApplications: false,
      judgmentDocs: this.attachedDocumentsTable,
      generalComment: ''
    }
  },
  methods: {
    loadAssignedApplications () {
      this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', 'printdecisionw_')
        .then(response => {
          if (response && response.length === 0) {
            this.$notify.warning({
              title: 'Ειδοποίηση',
              message: 'Δεν βρέθηκε καμία αίτηση σας. Αν αυτό δεν ισχύει επικοινωνήστε με τον διαχειριστή',
              offset: 100
            })
          }
        })
    },
    appsToReleaseChanged (apps) {
      this.appsToRelease = apps
    },
    appsToAssignChanged (apps) {
      this.appsToAssign = apps
    },
    changedGeneralCommentEvent (comment) {
      this.generalComment = comment
    },
    changedAttachedDocsEvent (docs) {
      let docComments = ''
      docs.forEach(doc => {
        if (doc.precheckerComment) {
          // Todo: this comment must be in English according to language
          docComments +=
            `<div><b>Τύπος</b>: ${doc.type}, <b>Κατάσταση</b>: ${doc.precheckerChecked ? 'Αποδεκτό' : 'Με εκκρεμότητα'}, <b>Σχόλιο</b>: ${doc.precheckerComment}</div>`
        }
      })
      this.judgmentDocs = docComments
    },
    loadAppsOpenDialog () {
      this.loadPrintDecisionsApplications()
      this.dialogView = true
    },
    appLabel (app) {
      const appId = app.id
      let appType = '---'
      const label = `${app.surname} ${app.name.substring(0, 1)}., ${app.submittedAt.substring(0, 10)}, ${app.protocol}`
      if (app.applicationType === 'ΕΠΑΝΕΞΕΤΑΣΗΣ ΑΙΤΗΜΑΤΟΣ ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ ΣΠΟΥΔΩΝ') {
        appType = 'Επανεξέταση'
      } else if (app.applicationType === 'ΕΚΔΟΣΗΣ ΠΡΑΞΗΣ ΜΕΤΑ ΑΠΟ ΕΞΕΤΑΣΕΙΣ') {
        appType = 'Μετά από εξετάσεις'
      } else if (app.degreeType) {
        appType = app.degreeType
      }
      return `${appId} - ${appType}, ${label}`
    },
    loadPrintDecisionsApplications () {
      this.loadingAllApplications = true
      axios.get(`${this.BASE_URL}/printdecisions/uid/applications`)
        .then((response) => {
          this.listPrintDecisionApplications = response.data.data.map(
            application => {
              return {
                key: application.id,
                label: this.appLabel(application),
                disabled: false
              }
            })
          this.allApplications = this.listPrintDecisionApplications.concat(this.listAssignedApplications)
          this.loadingAllApplications = false
        }, (err) => {
          this.backendError(err)
        })
    },
    loadViewApplication (id) {
    },
    saveNewApplications (action) {
      axios.put(
        `${this.BASE_URL}/printdecisions/uid/applications`,
        { applications: this.myApplications, apps: action === 'assign' ? this.appsToAssign : this.appsToRelease, action: action }
      ).then((response) => {
        this.loadAssignedApplications()
      })
    },
    newAssignedApplications (newApps) {
      let appNumber = this.myApplications.length - this.assignedApplications.length
      let action = appNumber > 0 ? 'assign' : 'release'
      let warning = appNumber > 0
        ? 'Θα αναλάβετε ' + appNumber +
          (appNumber === 1
            ? ' νέα αίτηση την: ' + this.appsToAssign
            : ' νέες αιτήσεις ' + this.appsToAssign
          )
        : 'Θα αποδεσμεύσετε ' + (0 - appNumber) +
          (0 - appNumber === 1
            ? ' αίτηση την: ' + this.appsToRelease
            : ' αιτήσεις τις: ' + this.appsToRelease
          )
      warning += '. Συνολικά θα έχετε ' + this.myApplications.length + '. Αν δεν συμφωνείτε πατήστε άκυρο!'
      this.$confirm(warning, 'Προσοχή!!!', {
        confirmButtonText: 'Ναι',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        this.dialogView = false
        this.myApplications = newApps
        this.saveNewApplications(action)
      }).catch(() => {
        this.myApplications = this.assignedApplications
        this.dialogView = false
        this.$message({
          type: 'info',
          message: 'Η ανάληψη-αποδέσμευση ακυρώθηκε'
        })
      })
    },
    toggleNewApplications () {
      this.openNewApplications = !this.openNewApplications
    },
    handleClick (tab, event) {
    }
  },
  computed: {
    generalCommentWorking () {
      let history = this.workingApplication.applicationHistory
      return history[history.length - 1].judgment !== null &&
        history[history.length - 1].judgment.comment !== null
        ? history[history.length - 1].judgment.comment
        : ''
    },
    generalCommentInDocs () {
      let comments = []
      let history = this.workingApplication.applicationHistory.slice(0)
      comments = history[history.length - 1].judgment !== null &&
        history[history.length - 1].judgment.comment !== null
        ? history
          .filter(step => step.applicationStatus === 'PREPROCESS_TEMPORARY')
        : []
      return comments
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).filter(docu => docu.type !== 22).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    isPostExam () {
      return this.workingApplication.applicationType === 'compensatory'
    },
    isSecondReappraisal () {
      return this.workingApplication.reappraisalSecondDegree
    },
    ...mapState([
      'searchVisible',
      'searchUniVisible',
      'history',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL'
    ])
  },
  watch: {
    workingApplication: function (newData, oldData) {
      this.activeName = 'sixth'
    },
    assignedApplications: {
      handler: function (newData, oldData) {
        this.listAssignedApplications = this.assignedApplications.map(
          application => {
            return { key: application.id,
              label: this.appLabel(application),
              disabled: false
            }
          })
        this.myApplications = []
        this.assignedApplications.forEach(app => {
          this.myApplications.push(app.id)
        })
      },
      deeep: true
    }
  }
}
</script>

<style lang="scss">
.el-transfer-panel .el-transfer-panel__footer {
  text-align: center;
}
div.el-transfer-panel {
  width: 500px
}
.newApplicationsMenu {
  background-color: #c8ec3c;
  /*color: #7a9db7;*/
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrintDecision.vue